/* ============================================================
   Magazine Header — 2nd-level submenu behaviour (material -> colour)
   Works alongside the inline whole-menu toggle script in
   sections/mag-header.liquid (that script opens/closes the entire
   .mag-masthead__nav on mobile; this one drives the per-item
   disclosure submenus nested inside it).

   Desktop (>=1401px, matches mag-base.css breakpoint):
     - Reveal is JS-owned: the panel only shows via .is-open
       (mag-base.css). This script is the single authority that
       toggles that class — CSS carries no independent :hover /
       :focus-within reveal at this breakpoint while JS is running.
     - No-JS fallback lives entirely in CSS: mag-base.css's
       @media (scripting: none) block restores a hover/:focus-within
       reveal for when this script never loads. That block is inert
       whenever scripting is available, so it never fights .is-open.
     - aria-expanded and child tabindex track .is-open.
     - Pointer-caused focus is not treated as a keyboard open: a
       pointerdown on the group sets a short-lived flag that tells
       the very next focusin to skip calling open() (the click
       handler below owns opening/closing for pointer input).
     - Escape closes the panel, moves focus back to the parent
       link/toggle, and sets a suppression flag so that focus-move's
       own focusin doesn't immediately reopen it. The flag has no
       timer — it lives until the group is actually left (focusout
       to outside the group resets it) or the panel is opened again
       through any other path (hover, click, arrow-key — open()
       resets it on entry). Net effect: Escape then Tab leaves the
       panel closed; only leaving the group or re-triggering an
       open reactivates it.
   Mobile (<=1400px):
     - No hover; the toggle button drives a click-to-open accordion.
============================================================ */

(function () {
  'use strict';

  var groups = document.querySelectorAll('[data-mag-nav-group]');
  if (!groups.length) return;

  var DESKTOP_QUERY = '(min-width: 1401px)';
  var desktopMq = window.matchMedia(DESKTOP_QUERY);

  function isDesktop() {
    return desktopMq.matches;
  }

  groups.forEach(function (group) {
    var toggle = group.querySelector('[data-mag-submenu-toggle]');
    var submenu = group.querySelector('[data-mag-submenu]');
    var parentLink = group.querySelector('.mag-masthead__nav-item--parent');
    if (!toggle || !submenu) return;

    var links = Array.prototype.slice.call(submenu.querySelectorAll('a'));
    var suppressFocusOpen = false;
    var pointerFocus = false;

    group.addEventListener('pointerdown', function () {
      pointerFocus = true;
      setTimeout(function () {
        pointerFocus = false;
      }, 0);
    });

    function setChildrenTabbable(tabbable) {
      links.forEach(function (a) {
        a.tabIndex = tabbable ? 0 : -1;
      });
    }

    function isOpen() {
      return group.classList.contains('is-open');
    }

    function open() {
      group.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      setChildrenTabbable(true);
      suppressFocusOpen = false;
    }

    function close() {
      group.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      setChildrenTabbable(false);
    }

    // Explicit toggle — covers touch (no hover) and Enter/Space on the button.
    toggle.addEventListener('click', function () {
      if (isOpen()) {
        close();
      } else {
        open();
      }
    });

    // Desktop hover: CSS reveals the panel on its own; this keeps
    // aria-expanded/tabindex in sync with that visual state.
    group.addEventListener('mouseenter', function () {
      if (isDesktop()) open();
    });
    group.addEventListener('mouseleave', function () {
      if (isDesktop() && !group.contains(document.activeElement)) close();
    });

    // Keyboard focus entering the group: CSS :focus-within reveals the
    // panel; open() here keeps state in sync so Tab can continue into
    // the now-visible children instead of skipping tabindex="-1" links.
    group.addEventListener('focusin', function () {
      if (suppressFocusOpen || pointerFocus) return;
      open();
    });
    group.addEventListener('focusout', function (e) {
      if (!group.contains(e.relatedTarget)) {
        close();
        suppressFocusOpen = false;
      }
    });

    group.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        if (!isOpen()) return;
        suppressFocusOpen = true;
        close();
        (parentLink || toggle).focus({ preventScroll: true });
        e.stopPropagation();
        return;
      }

      if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp') return;

      var active = document.activeElement;
      var idx = links.indexOf(active);

      if (idx === -1) {
        // Focus is on the parent link or the toggle button: enter the list.
        if (e.key === 'ArrowDown' && links.length) {
          e.preventDefault();
          open();
          links[0].focus();
        }
        return;
      }

      e.preventDefault();
      if (e.key === 'ArrowDown') {
        (links[idx + 1] || links[0]).focus();
      } else {
        (links[idx - 1] || links[links.length - 1]).focus();
      }
    });

    // Start closed; children out of the tab sequence until opened.
    close();
  });

  // Desktop/mobile breakpoint crossing (e.g. rotating a tablet): drop any
  // stale open state, mirroring the hamburger-menu reset already in
  // sections/mag-header.liquid.
  var handleBreakpointChange = function () {
    groups.forEach(function (group) {
      group.classList.remove('is-open');
      var toggle = group.querySelector('[data-mag-submenu-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
      var childLinks = group.querySelectorAll('[data-mag-submenu] a');
      childLinks.forEach(function (a) {
        a.tabIndex = -1;
      });
    });
  };
  desktopMq.addEventListener
    ? desktopMq.addEventListener('change', handleBreakpointChange)
    : desktopMq.addListener(handleBreakpointChange);
})();
